import { useCallback, useMemo } from 'react';
import useCaseClusterList from '@/features/caseCluster/hooks/useCaseClusterList';
import useAllClientList from '@/features/clients/hooks/useAllClientList';
import { Meeting } from '@/services/API';
import useCaseClusterSubscription from '@/services/subscriptions/useCaseClusterSubscription';
import useMeetingSubscription from '@/services/subscriptions/useMeetingSubscription';
import { MeetingSelectors } from '@/store/slices/meeting';
import { useAppDispatch, useAppSelector } from '@/store/StoreHooks';
import { deleteACaseCluster } from '@/store/thunk/caseCluster/deleteCaseCluster';
import { PageLoading } from '@/ui/PageLoading';
import AdminCaseClusterListView from './AdminCaseClusterListView';
import { AdminCaseClusterListItemType } from './columns';

export default function AdminCaseClusterListClient() {
  const caseClusterList = useCaseClusterList();
  const allClients = useAllClientList();
  const meetingList: Meeting[] = useAppSelector(MeetingSelectors.getMeetingList);
  const dispatch = useAppDispatch();

  useCaseClusterSubscription();
  useMeetingSubscription();

  const handleDeleteCaseCluster = useCallback((caseClusterID: string) => {
    dispatch(deleteACaseCluster(caseClusterID));
  }, []);

  const data: AdminCaseClusterListItemType[] = useMemo(() => {
    if (!allClients) return [];
    if (!caseClusterList) return [];

    return caseClusterList.map((caseCluster) => {
      const linkedClients = allClients.filter((client) =>
        caseCluster.clientIDs?.includes(client.id)
      );
      return {
        ...caseCluster,
        linkedMeetings: meetingList.filter((meeting) => caseCluster.id === meeting.caseClusterID),
        canBeDeleted: !meetingList.some((s) => s.caseClusterID === caseCluster.id),
        clients: linkedClients,
        clientText: linkedClients.map((client) => client.clientName).join(', '),
      };
    });
  }, [caseClusterList, meetingList]);

  if (!caseClusterList) {
    return <PageLoading />;
  }
  return (
    <>
      <AdminCaseClusterListView data={data} handleDeleteCaseCluster={handleDeleteCaseCluster} />
    </>
  );
}
